// libs
import React, { useMemo } from 'react';

import { cn } from '@lyearn/style';
// components
import { Box } from '@lyearn/ui';

// helpers
import { getScores } from '../../helpers/getScores';
import Score from '../Score';

function ScoreBox({
  className,
  questionId,
  maxScore,
  score,
  isDisabled = true,
  onAction,
}: {
  className?: string;
  questionId: string;
  maxScore: number;
  score?: number;
  isDisabled?: boolean;
  onAction?: (id: string, feebackType: 'score' | 'input', score: number) => void;
}) {
  const scores = useMemo(() => getScores(maxScore, score), [maxScore, score]);

  return (
    <Box className={cn('mb-12 flex flex-row flex-wrap', className)}>
      {scores.map((score, index) => {
        const { score: reviewScore, value, isSelected } = score;

        return (
          <Score
            key={reviewScore}
            classname={cn('mt-12', {
              'me-8 xs:me-14': scores.length - 1 !== index,
            })}
            isDisabled={isDisabled}
            isSelected={isSelected}
            questionId={questionId}
            score={reviewScore}
            value={value}
            onAction={onAction}
          />
        );
      })}
    </Box>
  );
}

export default ScoreBox;
